module.exports = __webpack_public_path__ + "img/UTBEAR-3.2494c7db.jpg";